<template>
  <BaseFormGroup
    data-class="base-select-field"
    class="base-select-field"
    :columnInfo="columnInfo"
    v-if="columnInfo.visible()"
    v-bind="$attrs"
  >
    <BaseSelect
      v-model="_value"
      :columnInfo="columnInfo"
      :error-visible="errorVisible"
      :options="options"
      :rules="rules"
      :state="state"
      v-bind="$attrs"
      v-on="$listeners"
      @change="$emit('change')"
    />
  </BaseFormGroup>
</template>

<script>
export default {
  name: 'BaseSelectField',

  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number],
      default: '',
    },

    /**
     * 定義情報.
     * @type {Object}
     * @requires
     */
    columnInfo: {
      type: Object,
      required: true,
    },

    /**
     * 選択肢リスト.
     * @type {Array}
     */
    options: {
      type: Array,
      default: () => [],
    },

    /**
     * バリデーションチェックの状態を表示するか.
     * @type {Boolean}
     */
    state: {
      type: Boolean,
      default: false,
    },

    /**
     * 入力検証ルール.
     * @type {String}
     */
    rules: {
      type: Array,
      default: () => [],
    },

    /**
     * エラーメッセージを表示するか.
     * @type {Boolean}
     */
    errorVisible: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    _value: {
      get() {
        return this.value
      },

      set(v) {
        if (this.value !== v) this.$emit('input', v)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.base-select-field {
  margin: 0;
  padding: 0;
}
</style>
